import { render } from "./FooterNav.vue?vue&type=template&id=77db3b9a&scoped=true&bindings={}"
import script from "./FooterNav.vue?vue&type=script&lang=ts"
export * from "./FooterNav.vue?vue&type=script&lang=ts"

import "./FooterNav.vue?vue&type=style&index=0&id=77db3b9a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-77db3b9a"

export default script